// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Sjtv","colBig":"styles_colBig__-Qu0Y","colSmall":"styles_colSmall__3Qszu"};